module.exports = __webpack_public_path__ + "static/media/IVTherapy.4c1601cb.jpg";